// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchNodes__searchWarning___tbhcn {
    margin-top: 2px;
    margin-left: 9px;
    color: coral;
}

.SearchNodes__searchResults___R3_4J {
    margin-left: 6px;
}

.SearchNodes__favoritesPanel___FfLtw {
    margin: 6px 5px;
}

.SearchNodes__favoritesHeader____LCsn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 4px;
    color: rgba(226, 205, 166, 0.65);
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 0.11em;
    text-transform: uppercase;
    text-shadow: 0 0 5px rgba(222, 177, 93, 0.14);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchWarning": `SearchNodes__searchWarning___tbhcn`,
	"searchResults": `SearchNodes__searchResults___R3_4J`,
	"favoritesPanel": `SearchNodes__favoritesPanel___FfLtw`,
	"favoritesHeader": `SearchNodes__favoritesHeader____LCsn`
};
module.exports = ___CSS_LOADER_EXPORT___;
